module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/ecommerce-header-style5/ecommerce-header-style5.component.scss
// module id = ./src/app/features/headers-styles/ecommerce-header-style5/ecommerce-header-style5.component.scss
// module chunks = main